import { css } from 'styled-components'

import nordeaSansBold from './NordeaSansSmallWeb/NordeaSansSmallWeb-Bold.woff'
import nordeaSansBold2 from './NordeaSansSmallWeb/NordeaSansSmallWeb-Bold.woff2'
import nordeaSansLight from './NordeaSansSmallWeb/NordeaSansSmallWeb-Light.woff'
import nordeaSansLight2 from './NordeaSansSmallWeb/NordeaSansSmallWeb-Light.woff2'
import nordeaSansMedium from './NordeaSansSmallWeb/NordeaSansSmallWeb-Medium.woff'
import nordeaSansMedium2 from './NordeaSansSmallWeb/NordeaSansSmallWeb-Medium.woff2'
import nordeaSansRegular from './NordeaSansSmallWeb/NordeaSansSmallWeb-Regular.woff'
import nordeaSansRegular2 from './NordeaSansSmallWeb/NordeaSansSmallWeb-Regular.woff2'
import robotoLatin300Woff from './roboto-v27-latin/roboto-v27-latin-300.woff'
import robotoLatin300Woff2 from './roboto-v27-latin/roboto-v27-latin-300.woff2'
import robotoLatin400Woff from './roboto-v27-latin/roboto-v27-latin-400.woff'
import robotoLatin400Woff2 from './roboto-v27-latin/roboto-v27-latin-400.woff2'
import robotoLatin500Woff from './roboto-v27-latin/roboto-v27-latin-500.woff'
import robotoLatin500Woff2 from './roboto-v27-latin/roboto-v27-latin-500.woff2'
import robotoLatin700Woff from './roboto-v27-latin/roboto-v27-latin-700.woff'
import robotoLatin700Woff2 from './roboto-v27-latin/roboto-v27-latin-700.woff2'

export default css`/* poppins-300 - latin */
	/* roboto-300 - latin */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 300;
		src: local(''),
			url(${robotoLatin300Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${robotoLatin300Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
	/* roboto-400 - latin */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 400;
		src: local(''),
			url(${robotoLatin400Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${robotoLatin400Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
	/* roboto-500 - latin */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 500;
		src: local(''),
			url(${robotoLatin500Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${robotoLatin500Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
	/* roboto-700 - latin */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 700;
		src: local(''),
			url(${robotoLatin700Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${robotoLatin700Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}

	@font-face {
		font-family: 'Nordea Sans';
		font-style: normal;
		font-weight: 700;
		src:
			url(${nordeaSansBold2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${nordeaSansBold}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}

	@font-face {
		font-family: 'Nordea Sans';
		font-style: normal;
		font-weight: 500;
		src:
			url(${nordeaSansMedium2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${nordeaSansMedium}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}

	@font-face {
		font-family: 'Nordea Sans';
		font-style: normal;
		font-weight: 400;
		src:
			url(${nordeaSansRegular2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${nordeaSansRegular}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}

	@font-face {
		font-family: 'Nordea Sans';
		font-style: normal;
		font-weight: 300;
		src:
			url(${nordeaSansLight2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${nordeaSansLight}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
`
